var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-input"},[_c('p',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]),_c('input',{ref:"input",attrs:{"type":_vm.type},on:{"input":function($event){return _vm.updateValue()}}}),_c('p',{staticClass:"warning"})])}
var staticRenderFns = []

export { render, staticRenderFns }